<template>
    <v-container fluid>   
      <LeftMenu/>     
        <v-layout row wrap>

            <v-flex xs1/>
            <v-flex xs11>
             
              <v-row
                class="mb-6"
                no-gutters
              >
                <v-col md="11"  
                >
                  <v-card
                    height="100%"
                    class="pa-5"
                    outlined
                    tile
                  >
                    <v-layout row wrap>                                         
                      <v-flex xs12>
                        <ReportByProduct/>
                      </v-flex>                                            
                    </v-layout>                                        
                  </v-card>
                </v-col>

                <v-col md="1"  
                >
                  
                </v-col>
              </v-row>
              
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import LeftMenu from '../../components/LeftMenu';
import ReportByProduct from '../reports/ReportByProduct';

export default {
  components:{
    LeftMenu,
    ReportByProduct

  },
  name: 'SalesReport',  
  data() {
    return {
      periodList: [],
      selectedEndDate: {},
      selectedStartDate: {},
    }
  },
  created() {        
  },
  methods: {   
  }       

}
</script>
